import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseWidgetModule } from '@fuse/components';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DateModule } from '../misc/date.module';
import { ReportOptionsComponent } from './report-options/report-options.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { ReportDesignerComponent } from './report-designer/report-designer.component';
import { DxReportDesignerModule } from 'devexpress-reporting-angular';
import {
  DevExtremeModule,
  DxLoadIndicatorModule,
  DxTemplateHost,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { DxLoadPanelModule } from 'devextreme-angular';
import { CheckListComponentModule } from 'app/components/check-list/check-list.module';
import {
  // DatePickerComponent,
  ReportComponent,
} from './report/report.component';
import { ReportsComponent } from './reports/reports.component';
import { ComponentsModule } from 'app/components/components.module';
import { ReportDialogComponent } from './report-dialog/report-dialog.component';
import { AuthGuardService } from 'app/shared/services/auth-guard.service';
import { ReferralReportsComponent } from './referral-reports/referral-reports.component';
import { ReferralReportService } from 'app/shared/services/reporting/referral-report.service';
import { SystemReportService } from 'app/shared/services/reporting/system-report.service';
import { ReportExtractComponent } from './report-extract/report-extract.component';
import { CanDeactivateGuard } from 'app/shared/guards/can-deactivate.guard';
import { ReportDashboardComponent } from './report-dashboard/report-dashboard.component';
import {
  DxDashboardControlComponent,
  DxDashboardControlModule,
} from 'devexpress-dashboard-angular';
import {
  DxButtonModule,
  DxChartModule,
  DxPieChartModule,
} from 'devextreme-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DeleteDashboardExtension } from './report-dashboard/extensions/delete-dashboard-extension';
import { ReportDashboardService } from 'app/shared/services/reporting/report-dashboard.service';
import { InputPopupComponent } from './report-dashboard/input-popup/input-popup.component';
const routes = [
  {
    path: 'reports',
    component: ReportsComponent,
    resolve: {
      files: SystemReportService,
    },
    canActivate: [AuthGuardService],
    data: { auth: 'ADMIN, USER,ORGMANAGER' },
  },
  {
    path: 'reports/:id',
    component: ReportComponent,
    // canDeactivate: [CanDeactivateGuard],
    resolve: {
      files: SystemReportService,
    },
    canActivate: [AuthGuardService],
    data: { auth: 'ADMIN, USER,ORGMANAGER' },
  },
  {
    path: 'reportdesigner',
    component: ReportDesignerComponent,
    canActivate: [AuthGuardService],
    data: { auth: 'SYSADMIN' },
  },
  {
    path: 'reportextract',
    component: ReportExtractComponent,
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuard],
    data: { auth: 'ADMIN, SYSADMIN' },
  },
  {
    path: 'reportdashboard',
    component: ReportDashboardComponent,
    canActivate: [AuthGuardService],
    data: { auth: 'ADMIN, USER, ORGMANAGER, SYSADMIN' },
  },
  {
    path: 'referralreports',
    component: ReferralReportsComponent,
    resolve: {
      files: ReferralReportService,
    },
    canActivate: [AuthGuardService],
    data: { auth: 'ADMIN, USER, ORGMANAGER' },
  },
  {
    path: 'referralreports/:id',
    component: ReportComponent,
    // canDeactivate: [CanDeactivateGuard],
    resolve: {
      files: ReferralReportService,
    },
    canActivate: [AuthGuardService],
    data: { auth: 'ADMIN, USER, ORGMANAGER' },
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FuseSharedModule,
    // NgxChartsModule,
    MatOptionModule,
    MatSelectModule,
    FuseWidgetModule,
    MatIconModule,
    MatFormFieldModule,
    MatDialogModule,
    MatDatepickerModule,
    MatInputModule,
    MatSidenavModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDividerModule,
    MatToolbarModule,
    MatTooltipModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    DateModule,
    MatMenuModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatTabsModule,
    PhoenixDirectivesModule,
    DxReportDesignerModule,
    CheckListComponentModule,
    ComponentsModule,
    DxDashboardControlModule,
    DxChartModule,
    DxPieChartModule,
    DxButtonModule,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
    DevExtremeModule,
  ],
  declarations: [
    ReportsComponent,
    ReportComponent,
    ReferralReportsComponent,
    ReportOptionsComponent,
    ReportDesignerComponent,
    ReportDialogComponent,
    ReportExtractComponent,
    ReportDashboardComponent,
    InputPopupComponent,
  ],
  providers: [
    SystemReportService,
    ReferralReportService,
    ReportDashboardService,
    DxDashboardControlComponent,
    DxTemplateHost,
    WatcherHelper,
    NestedOptionHost,
  ],
  exports: [
    ReportsComponent,
    ReportComponent,
    ReportDesignerComponent,
    ReferralReportsComponent,
    ReportExtractComponent,
    ReportDashboardComponent,
    InputPopupComponent,
  ],
})
export class ReportingModule {}
